// Resolve a stored upload path (e.g. "/uploads/2026/06/x.webp") to a full URL.
// Uploads are served by the API origin, which is REACT_APP_API_URL minus "/api".
const ORIGIN = (process.env.REACT_APP_API_URL || "http://localhost:4000/api").replace(/\/api\/?$/, "");

export const mediaUrl = (path) =>
  !path ? null : path.startsWith("http") ? path : `${ORIGIN}${path}`;
